import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // No need to do anything on connect
  }

  previewImage(event) {
    const input = event.target;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Validate file size (10MB max)
      if (file.size > 10 * 1024 * 1024) {
        alert("File is too large. Maximum size is 10MB.");
        input.value = "";
        return;
      }

      // Validate file type
      if (!["image/jpeg", "image/png"].includes(file.type)) {
        alert("Invalid file type. Please upload a JPEG or PNG image.");
        input.value = "";
        return;
      }
    }
  }
}
